import React from "react"

import "./style.scss"

const WhiteCheckBox = ({ ...props }) => {
  return <input type="checkbox" className="wcb-wrapper" {...props} />
}

export { WhiteCheckBox }
